import CardPanel from '@/components/CardPanel';
import { Table } from 'antd';
import dayjs from 'dayjs';
import { FC } from 'react';

const GroupAccessPage: FC = () => {
	return (
		<CardPanel title="Group Access">
			<Table
				size="middle"
				columns={[
					{
						title: '#',
						dataIndex: 'key',
						width: 60,
						align: 'center',
						render(key) {
							return key + 1;
						},
					},
					{
						title: 'Username',
						dataIndex: 'username',
					},
					{
						title: 'Status',
						dataIndex: 'isActive',
						render(isActive) {
							return isActive ? 'Active' : 'Inactive';
						},
					},
					Table.EXPAND_COLUMN,
				]}
				dataSource={[
					{
						key: 0,
						username: 'mtf-admin',
						isActive: true,
						createdAt: dayjs.unix(Date.now()),
					},
					{
						key: 1,
						username: 'mtf-user',
						isActive: true,
						createdAt: dayjs.unix(Date.now()),
					},
				]}
				onRow={() => ({
					style: {
						cursor: 'pointer',
					},
				})}
				expandable={{
					expandRowByClick: true,
					expandedRowRender() {
						return (
							<div style={{ padding: 16 }}>
								<div>
									Lorem ipsum dolor sit amet consectetur adipisicing elit.
									Laborum maiores, in inventore est soluta veritatis, fugit
									facilis doloribus sapiente deleniti atque neque obcaecati,
									officiis ratione numquam sunt assumenda quod. Et.
								</div>
							</div>
						);
					},
				}}
			/>
		</CardPanel>
	);
};

export default GroupAccessPage;
